<template>
    <table class="w-100" border="1">
        <tr>
            <th colspan="2">Summary</th>
        </tr>
        <tr>
            <td>confirmed</td>
            <td>{{ confirmed | money }} EUR</td>
        </tr>
        <tr>
            <td>Charged</td>
            <td>{{ (disTableCharge + projectHolderTableCharge + othersTableCharge + disFeesTableCharge + dagFeesTableCharge + divFeesTableCharge) | money }} EUR</td>
        </tr>
        <tr>
            <td>Available</td>
            <td>{{ (confirmed - (disTableCharge + projectHolderTableCharge + othersTableCharge + disFeesTableCharge + dagFeesTableCharge + divFeesTableCharge)) | money }} EUR</td>
        </tr>
    </table>
</template>
<script>
    export default {
        props: {
            confirmed: {
                default: 0
            }
        },
        created () {
            App.dispatcher.listen('chargeChange', response => {
                if(response.type == 'disTable') {
                    this.disTableCharge = parseFloat(response.charge)
                }
                if(response.type == 'projectHolderTable') {
                    this.projectHolderTableCharge = parseFloat(response.charge)
                }
                if(response.type == 'othersTable') {
                    this.othersTableCharge = parseFloat(response.charge)
                }
                if(response.type == 'disFeesTable') {
                    this.disFeesTableCharge = parseFloat(response.charge)
                }
                if(response.type == 'dagFeesTable') {
                    this.dagFeesTableCharge = parseFloat(response.charge)
                }
                if(response.type == 'divFeesTable') {
                    this.divFeesTableCharge = parseFloat(response.charge)
                }
            })
        },

        data() {
            return {
                disTableCharge: 0,
                projectHolderTableCharge: 0,
                othersTableCharge: 0,
                disFeesTableCharge: 0,
                dagFeesTableCharge: 0,
                divFeesTableCharge: 0,
            };
        },

        filters: {
            money(value) {
                return new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format((value));
            },
        }
    }
</script>
